
import NavBar from '../../components/feature/NavBar';
import Portfolio from '../home/components/Portfolio';
import Testimonials from '../home/components/Testimonials';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const portfolioJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'IT Deployment Portfolio & Testimonials | ZJF IT Services LLC',
    description: 'Browse real-world IT deployment projects completed by ZJF IT Services LLC — enterprise workstation rollouts, structured cabling, and office IT transitions across New York and nationwide.',
    url: `${siteUrl}/portfolio`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Portfolio', item: `${siteUrl}/portfolio` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'ZJF IT Services Deployment Portfolio',
    description: 'Real-world examples of structured IT deployments and infrastructure transformations by ZJF IT Services LLC.',
    url: `${siteUrl}/portfolio`,
  },
];

export default function PortfolioPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="IT Deployment Portfolio & Testimonials | ZJF IT Services LLC"
        description="Browse real-world IT deployment projects completed by ZJF IT Services LLC — enterprise workstation rollouts, structured cabling, and office IT transitions across New York and nationwide."
        keywords="IT deployment portfolio, workstation rollout projects, IT case studies New York, enterprise IT deployments, client testimonials"
        canonical={`${siteUrl}/portfolio`}
        jsonLd={portfolioJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">Our Work</span>
          <h1 className="text-5xl font-bold text-white mb-4">Deployment Portfolio</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Real-world examples of structured IT deployments and infrastructure transformations.
          </p>
        </div>
        <Portfolio />
        <Testimonials />
      </div>
    </div>
  );
}
